import script from "./SfxTableThStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxTableThStatus.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTh from 'quasar/src/components/table/QTh.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTh,QMenu,QList,QItem});
